import { render } from "./Block2.vue?vue&type=template&id=e0d61440&scoped=true"
import script from "./Block2.vue?vue&type=script&lang=js"
export * from "./Block2.vue?vue&type=script&lang=js"

import "./Block2.vue?vue&type=style&index=0&id=e0d61440&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d61440"]])

export default __exports__